module.exports = __webpack_public_path__ + "img/sword-air-06.5848fde3.png";